// @flow
import { path } from 'ramda';

import i18n from 'app/i18n';


const exchangeComplexErrorProcessing: (foodMode: string, date: string) => (error: Error) => string = (
  (foodMode: string, date: string) => (error: Error): string => {
    const errCode = path(['response', 'status'], error);
    const message = path(['response', 'data', 'message'], error);

    if (errCode === 403) {
      if (message === 'bad order status') {
        return i18n.t('cafeteria:order_request_sales_exchange_complex_bad_order_status_error', { foodMode, date });
      }
      if (message === 'order has been changed') {
        return i18n.t('cafeteria:order_request_sales_exchange_complex_order_has_been_changed_error', { foodMode, date });
      }
      if (message === 'order in queue') {
        return i18n.t('cafeteria:order_request_sales_exchange_complex_order_in_queue_error', { foodMode, date });
      }
      if (message === 'time expired') {
        return i18n.t('cafeteria:order_request_sales_exchange_complex_time_expired_error', { foodMode, date });
      }
    }
    return i18n.t('cafeteria:order_request_sales_exchange_complex_submit_error', { foodMode, date });
  }
);

export default exchangeComplexErrorProcessing;
